var map = {
	"./views/authentication/authentication.module": [
		"./src/app/views/authentication/authentication.module.ts",
		"authentication.module"
	],
	"./views/best-rates/best-rates.module": [
		"./src/app/views/best-rates/best-rates.module.ts",
		"best-rates.module"
	],
	"./views/cdr-files-table/cdr-files-table.module": [
		"./src/app/views/cdr-files-table/cdr-files-table.module.ts",
		"cdr-files-table.module"
	],
	"./views/charge-details/charge-details.module": [
		"./src/app/views/charge-details/charge-details.module.ts",
		"common",
		"charge-details.module"
	],
	"./views/contract-lines/contract-lines.module": [
		"./src/app/views/contract-lines/contract-lines.module.ts",
		"common",
		"contract-lines.module"
	],
	"./views/dashboard/dashboard.module": [
		"./src/app/views/dashboard/dashboard.module.ts",
		"common",
		"dashboard.module"
	],
	"./views/details-number-lines/details-number-lines.module": [
		"./src/app/views/details-number-lines/details-number-lines.module.ts",
		"common",
		"details-number-lines.module"
	],
	"./views/details-personal-spent/details-personal-spent.module": [
		"./src/app/views/details-personal-spent/details-personal-spent.module.ts",
		"common",
		"details-personal-spent.module"
	],
	"./views/details-totalAccount/details-totalAccount.module": [
		"./src/app/views/details-totalAccount/details-totalAccount.module.ts",
		"common",
		"details-totalAccount.module"
	],
	"./views/details_lines/details_lines.module": [
		"./src/app/views/details_lines/details_lines.module.ts",
		"common",
		"details_lines.module"
	],
	"./views/human-resources/human-resources.module": [
		"./src/app/views/human-resources/human-resources.module.ts",
		"common",
		"human-resources.module"
	],
	"./views/lines-intelligence/lines-intelligence.module": [
		"./src/app/views/lines-intelligence/lines-intelligence.module.ts",
		"common",
		"lines-intelligence.module"
	],
	"./views/locations-map/locations-map.module": [
		"./src/app/views/locations-map/locations-map.module.ts",
		"common",
		"locations-map.module"
	],
	"./views/locationsG/locationsG.module": [
		"./src/app/views/locationsG/locationsG.module.ts",
		"common",
		"locationsG.module"
	],
	"./views/menu-admin/menu-admin.module": [
		"./src/app/views/menu-admin/menu-admin.module.ts",
		"menu-admin.module"
	],
	"./views/optimization-graph/optimization-graph.module": [
		"./src/app/views/optimization-graph/optimization-graph.module.ts",
		"common",
		"optimization-graph.module"
	],
	"./views/optimization-pdf-deliverable/optimization-pdf-deliverable.module": [
		"./src/app/views/optimization-pdf-deliverable/optimization-pdf-deliverable.module.ts",
		"common",
		"optimization-pdf-deliverable.module"
	],
	"./views/payed-months/payed-months.module": [
		"./src/app/views/payed-months/payed-months.module.ts",
		"common",
		"payed-months.module"
	],
	"./views/payment-form/payment-form.module": [
		"./src/app/views/payment-form/payment-form.module.ts",
		"common",
		"payment-form.module"
	],
	"./views/plan-statistics/plan-statistics.module": [
		"./src/app/views/plan-statistics/plan-statistics.module.ts",
		"common",
		"plan-statistics.module"
	],
	"./views/renewal-lines/renewal-lines.module": [
		"./src/app/views/renewal-lines/renewal-lines.module.ts",
		"common",
		"renewal-lines.module"
	],
	"./views/statistics/statistics.module": [
		"./src/app/views/statistics/statistics.module.ts",
		"statistics.module"
	],
	"./views/tags-strategy-selector/tags-strategy-selector.module": [
		"./src/app/views/tags-strategy-selector/tags-strategy-selector.module.ts",
		"common",
		"tags-strategy-selector.module"
	],
	"./views/top-data/top-data.module": [
		"./src/app/views/top-data/top-data.module.ts",
		"common",
		"top-data.module"
	],
	"./views/top-roaming/top-roaming.module": [
		"./src/app/views/top-roaming/top-roaming.module.ts",
		"common",
		"top-roaming.module"
	],
	"./views/total-graph/total-graph.module": [
		"./src/app/views/total-graph/total-graph.module.ts",
		"common",
		"total-graph.module"
	],
	"./views/upload-cdr-file/upload-cdr-file.module": [
		"./src/app/views/upload-cdr-file/upload-cdr-file.module.ts",
		"upload-cdr-file.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main